import querystring, { type ParsedUrlQueryInput } from 'querystring';

export const concatQueryParams = (uri: string, queryParams: ParsedUrlQueryInput): string => {
    const params = Object.fromEntries(Object.entries(queryParams).filter(([_, value]) => value !== null && value !== undefined));
    if (Object.keys(params).length > 0) {
        const separator = uri.includes('?') ? '&' : '?';
        return `${uri}${separator}${querystring.stringify(params)}`;
    }
    return uri;
};

const replaceDashesInString = (text: string): string => text.replace(/-/gm, '|');

const replacePipesInString = (text: string): string => text.replace(/\|/gm, '-');

export const replaceDashes = (text: string | readonly string[] | undefined | null): string | readonly string[] | null => {
    if (Array.isArray(text)) {
        return text.map(replaceDashesInString);
    }

    if (typeof text === 'string') {
        return replaceDashesInString(text);
    }

    return null;
};

export const replacePipes = (text: string | readonly string[] | undefined | null): string | readonly string[] | null => {
    if (Array.isArray(text)) {
        return text.map(replacePipesInString);
    }

    if (typeof text === 'string') {
        return replacePipesInString(text);
    }

    return null;
};

export const stripWhitespace = (v: string): string => v?.trim()?.replace(/\s+/g, '');

export const isValidEmail = (email?: string): boolean => email?.length > 2 && email.includes('@');

export const isValidPhone = (cc: string, phone: string): boolean => {
    const stripCc = stripWhitespace(cc);
    const stripPhone = stripWhitespace(phone);
    return (
        stripCc.length > 0 &&
        stripCc.length <= 5 &&
        stripPhone.length > 6 &&
        stripPhone.length < 20 &&
        !Number.isNaN(Number.parseInt(stripPhone, 10))
    );
};
